import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Text} from "@mantine/core";
import {SubscriptionItem} from "../types.ts";

export const useTableColumns = (
    {onRecordClick}: { onRecordClick: (record: SubscriptionItem) => void },
) => {

    const columns: DataTableColumn<SubscriptionItem>[] = [
        {
            accessor: 'price',
            title: I18n.get('Product'),
            render: (record: SubscriptionItem) => (
                <Text
                    size="sm"
                    c="blue"
                    style={{cursor: 'pointer'}}
                    onClick={() => onRecordClick(record)}
                >
                    {record.price?.product?.name || `Price ID: ${record.priceId}`}
                </Text>
            ),
        },
        {
            accessor: 'quantity',
            title: I18n.get('Quantity'),
            render: (record: SubscriptionItem) => (
                <Text size="sm">
                    {record.quantity} {record.price?.billingPeriod ? `/ ${record.price.billingPeriod}` : ''}
                </Text>
            ),
        },
        {
            accessor: 'price.amount',
            title: I18n.get('Amount'),
            render: (record: SubscriptionItem) => (
                <Text size="sm">
                    {record.price?.amount ? `$${(record.price.amount / 100).toFixed(2)}` : 'N/A'}
                </Text>
            ),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
        },
    ];

    return {
        columns,
    };
};
